import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

const name = "sendEcards";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

// const extraReducers = createExtraReducers();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const sendEcardsActions = { ...slice.actions, ...extraActions };
export const sendEcardsReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    error: null,
    EcardListData: [],
    EcardDetailsResponse :[]
  };
}

function createReducers() {
  return {
    clearEcardListData,
  };

  function clearEcardListData(state) {
    state.EcardListData = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser`;

  return {
    LoadSendEcardList: LoadSendEcardList(),
    LoadEcardsDetails: LoadEcardsDetails(),
    LoadUpdateunreadPUEcardDetails: LoadUpdateunreadPUEcardDetails(),
  };

  function LoadSendEcardList() {
    return createAsyncThunk(
      `${name}/LoadInmateInboxECard`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/PublicEcard/LoadPublicInboxECard`, addFormData)
    );
  }

  function LoadEcardsDetails() {
    return createAsyncThunk(
      `${name}/LoadEcardDetails`,
      async ({ eCardId }) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicEcard/LoadEcardForPublicUserDetails?eCardId=${eCardId}`
        )
    );
  }

  function LoadUpdateunreadPUEcardDetails() {
    return createAsyncThunk(
      `${name}/LoadUpdateunreadPUEcardDetails`,
      async ({ eCardId, inmateId }) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicEcard/LoadUpdateunreadPUEcardDetails?eCardId=${eCardId}&inmateId=${inmateId}`
        )
    );
  }  
}

function createExtraReducers(builder) {
  builder
    // Load Ecard List Details
    .addCase(extraActions.LoadSendEcardList.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.LoadSendEcardList.fulfilled, (state, action) => {
      state.EcardListData = [];
      state.EcardListData = action.payload;
    })
    .addCase(extraActions.LoadSendEcardList.rejected, (state, action) => {
      state.error = action.error.message;
    })


      // Load Ecard Details
      .addCase(extraActions.LoadEcardsDetails.pending, (state) => {
        state.error = null;
      })
      .addCase(extraActions.LoadEcardsDetails.fulfilled, (state, action) => {
        state.EcardDetailsResponse = [];
        state.EcardDetailsResponse = action?.payload[0] || [];
      })
      .addCase(extraActions.LoadEcardsDetails.rejected, (state, action) => {
        state.error = action.error.message;
      });
}
